const firebaseConfig = {
    apiKey: "AIzaSyBnwsfXD04ZKrx2f8b80KtkistoZ5cXtXY",
    authDomain: "burj-al-arab-demo.firebaseapp.com",
    databaseURL: "https://burj-al-arab-demo.firebaseio.com",
    projectId: "burj-al-arab-demo",
    storageBucket: "burj-al-arab-demo.appspot.com",
    messagingSenderId: "1008148767955",
    appId: "1:1008148767955:web:8b7ea060a0c0b209aaa026"
  };
  export default firebaseConfig;